export enum vrStatuses {
  approved = "Approved",
  rejected = "Rejected",
  open = "Open",
  submitted = "Submitted",
}
